import { memo } from "react";
import PropTypes from "prop-types";
import {
  Icon,
  Tooltip,
} from "@chakra-ui/react";
import { FaBan, FaHourglassHalf } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { ANALYTICS_STATUSES } from "../../_constants/AnalyticsStatuses";

const AnalyticsStatusIcon = ({ status }) => {
  const { t } = useTranslation("planner");

  switch (status) {
    case ANALYTICS_STATUSES.not_supported: {
      return (
        <Tooltip hasArrow shouldWrapChildren label={t("analytics.not_supported_tip")}>
          <Icon as={FaBan} ml="1" />
        </Tooltip>
      );
    }
    case ANALYTICS_STATUSES.processing: {
      return (
        <Tooltip hasArrow shouldWrapChildren label={t("analytics.processing_tip")}>
          <Icon as={FaHourglassHalf} ml="1" />
        </Tooltip>
      );
    }
    default:
      return null;
  }
}

AnalyticsStatusIcon.propTypes = {
  status: PropTypes.string,
}

AnalyticsStatusIcon.defaultProps = {
  status: undefined,
}

export default memo(AnalyticsStatusIcon);
